module.exports = __webpack_public_path__ + "static/media/zs.126e1223.svg";